import React from 'react';
import {Link} from 'react-router';


class CreateShiftHeader extends React.Component {

    render () {
        return (
            <header className="create-shift-header">
                <div className="maxwidth-wrapper">
                    <div className="left">
                        <h1 className="page-title">Create shift</h1>
                    </div>
                    <div className="right">
                        {this.props.canCancel ? <Link to="agenda" className="btn btn-cancel">Cancel</Link> : null}
                        <button onClick={this.props.saveDraft} className={"btn btn-save-draft " + (this.props.completed ? "btn-orange" : "btn-gray")}>Save draft</button>
                    </div>
                </div>
            </header>
        );
    }
}

export default CreateShiftHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/CreateShiftHeader.js
 **/